import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
	AuthnService,
	ComponentBase,
	DeploymentContext,
	getParsedReturnUrl,
	WebAnalyticsService,
} from '@Common';
@Component({
	selector: 'acs',
	templateUrl: './acs.component.html',
	styleUrls: ['./acs.component.scss'],
	standalone: false,
})
export class AcsComponent extends ComponentBase implements OnInit {
	public showProgressIndicator = false;

	constructor(
		deploymentContext: DeploymentContext,
		private _authnService: AuthnService,
		private _webAnalyticsService: WebAnalyticsService,
		private _router: Router,
		private route: ActivatedRoute
	) {
		super(deploymentContext);
	}

	public async ngOnInit(): Promise<void> {
		this._authnService.clearJnjLoggedOut();

		this.showProgressIndicator = true;
		setTimeout(async () => {
			if (!(await this._authnService.isSSOAuthValid())) {
				this._router.navigate(['']);
				return;
			}

			const avoidInterpolationOfSensitiveVariablesBuildWarning =
				this._authnService.currentUsername;
			this._webAnalyticsService.trackEvent('login-via-jnj-sso', {
				category: 'successful-login',
				label: `${avoidInterpolationOfSensitiveVariablesBuildWarning} - ${this._authnService.userRole}`,
			});

			const target = getParsedReturnUrl(this.route);
			this._router.navigateByUrl(target);
		}, this._deploymentContext.progressIndicator.pauseForStaticIndicator);
	}
}
